<template>
  <hit-entity-browser
    v-if="model"
    :route="model.apiRoute"
    :title="browserTitle"
    :table-attributes="attributes"
    :data-list-config="dataListConfigToApply"
    :only-load-active-records="onlyLoadActiveEnabled && onlyLoadActiveRecords"
    :custom-filters="customFilters"
    :default-sort="{property: model.orderKey, order: model.orderOrder}"
    @item-selected="selectItem"
  />
</template>

<script>
import HitEntityBrowser from './HitEntityBrowser.vue';
import {HitModelMixin} from '../../../mixins';
import {useI18n} from 'vue-i18n';
import {HitUtils} from '@hit/components';
import {useUserProfileStore} from '../../../store';

export default {
  name: 'HitDynamicBrowser',
  mixins: [HitModelMixin],
  setup() {
    const {t} = useI18n();
    const userProfileStore = useUserProfileStore();
    return {t, userProfileStore};
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    browserTitle() {
      return this.t(
        `hit-base.common.browser-title-${HitUtils.camelToKebab(
          this.browserType
        )}`
      );
    },

    dataListConfigToApply() {
      return this.dataListConfig || this.model.dataListConfig;
    },

    /**
     * We can only pass the active filter if the column exists in for the given table
     */
    onlyLoadActiveEnabled() {
      return (
        this.model.allAttributes &&
        Object.keys(this.model.allAttributes).includes('active')
      );
    },

    attributes() {
      return this.userProfileStore.hasAccessToModule(
        this.model.baseModuleForRedirection
      )
        ? this.model.browserDisplayAttrs
        : this.model.confidentialBrowserDisplayAttrs;
    },
  },
  components: {
    HitEntityBrowser,
  },
  props: {
    /**
     * String defining the type of entity browser we need to display
     */
    browserType: {
      type: String,
      required: true,
    },

    /**
     * Filter selecton on active = true if set
     */
    onlyLoadActiveRecords: {
      type: Boolean,
      required: false,
      default: true,
    },

    customFilters: {
      type: Object,
      required: false,
    },

    dataListConfig: {
      type: Object,
      required: false,
    },
  },

  methods: {
    selectItem(data) {
      const item = new this.model(data);
      this.$emit('itemSelected', item);
    },
  },
  emits: ['itemSelected'],

  beforeMount() {
    this.model = this.getModel(this.browserType);
  },
};
</script>
